import Tooltip from '@shared/components/tooltips/workflow-tooltip';
import React from 'react';
import { StyledToolTip } from '@shared/components/tooltips/accordion-item-tooltip/accordion-item-tooltip.styles';
import { AccordionItemTooltipProps } from '@shared/components/tooltips/accordion-item-tooltip/accordion-item-toolip.types';

export const AccordionItemTooltip = ({
    label,
    children,
    top = -25,
    left = 40,
}: AccordionItemTooltipProps) => (
    <Tooltip
        text={label}
        top={top}
        left={left}
        stylesToolTip={StyledToolTip}
    >
        {children()}
    </Tooltip>
);
